
/**
 * Checks to see if input of type datetime-local is supported
 * by the current browser.
 */
export const validateDatePicker = () => {

  var input = document.createElement("input");

  input.setAttribute("type", "datetime-local");

  return input.type == "datetime-local";

};


/**
 * Determines the number of days in the select based
 * on the current month.
 */
export const buildDayPicker = (month, year) => {

  let days;

  if(month === '01' || month === '03' || month === '05' || month === '07' || month === '08' || month === '10' || month === '12') {

    days = 31;

  } else if(month === '04' || month === '06' || month === '09' || month === '11') {

    days = 30;

  } else {

    const isLeap = new Date(year, 1, 29).getMonth() == 1;

    isLeap ? days = 29 : days = 28;

  }

  const options = [];

  for(let i = 1; i <= days; i++) {

    const value = i < 10 ? "0" + i : i;

    const option = <option key={`day_${value}`} value={value}>{i}</option>

    options.push(option);

  }

  return options;

};

/**
 * Builds the year select.
 */
export const buildYearPicker = () => {

  const options = [];

  const date = new Date();
  const year = date.getFullYear();

  for(let i = 0; i <= 25; i++) {

    const value = year + i;

    const option = <option key={`year_${value}`} value={value}>{value}</option>

    options.push(option);

  }

  return options;

};
